"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fluent_provide_1 = require("../decorator/fluent_provide");
function makeFluentProvideDecorator(container) {
    var result = fluent_provide_1.default(container);
    return result;
}
exports.default = makeFluentProvideDecorator;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inversify-binding-decorators/lib/factory/fluent_provide_decorator_factory.js
// module id = 1174
// module chunks = 0